import React, { useMemo } from 'react';

import { Flex, Table } from 'antd';
import type {
	IQueryDisplayComponent
} from 'src/pages/observers/components/QueryDisplay/types';
import {
	CollapseQueryDisplay
} from 'src/pages/observers/components/QueryDisplay/styles';

export default function QueryDisplay(
	{
		queryResult,
		queryFields,
	}: IQueryDisplayComponent
) {
	const columns = useMemo(() => {
		return queryFields.map(({ field, }) => ({
			title: field,
			key: field,
			dataIndex: field,
		}));
	}, [ queryFields, ]);

	return (
		<CollapseQueryDisplay
			size='small'
			defaultActiveKey={'1'}
			items={[{
				key: '1',
				label: <Flex gap={8}>
                    intervalo de execução:
					<strong>{queryResult.executionInterval}ms</strong>
				</Flex>,
				children: <Table
					size='small'
					bordered
					scroll={{ x: true, }}
					columns={columns}
					dataSource={(queryResult.data)??[]}
				/>,
			},]}
		/>
	);
}
